import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LETTERS } from "./i18n";

export default function Speller() {
  const [inputValue, setInputValue] = useState<string>("");
  const { t } = useTranslation();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(
      event.target.value.replace(/[^a-zåäö\n ]/gi, "").toUpperCase()
    );
  };

  const letterToWordDictionary: Record<string, string> = Object.fromEntries(
    LETTERS.map((letter) => [letter, t(letter)])
  );

  function replaceLettersWithWords(
    text: string,
    dictionary: Record<string, string>
  ): string {
    return text
      .split("")
      .map((char) => {
        if (char === " ") return "\n";
        return dictionary[char] || char;
      })
      .join(" ") // add space between words
      .replace(/\s*\n\s*/g, "\n"); // remove extra spaces around newlines
  }

  return (
    <>
      <h1 className="text-4xl md:text-6xl font-semibold mb-8">{t("title")}</h1>
      <h5 className="text-xl mb-4">{t("tagline")}</h5>
      <div className="w-80">
        <input
          type="text"
          placeholder={t("input-placeholder")}
          className="w-full border py-2 px-3 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-slate-500"
          value={inputValue}
          onChange={handleInputChange}
        />
        <div className="mt-4 w-80">
          <h3 className="text-2xl whitespace-pre-line">
            {replaceLettersWithWords(inputValue, letterToWordDictionary)}
          </h3>
        </div>
      </div>
    </>
  );
}
